var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.952,
    height: 18.603,
    viewBox: "0 0 12.952 18.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10611"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "2638315_bin_delete_dust_erace_garbage_icon",
    d: "M12.182 14.727H4.545V5.818H3.273v8.718A1.454 1.454 0 0 0 4.545 16h7.636a1.454 1.454 0 0 0 1.273-1.464V5.818h-1.272zM6.455 7.091v6.364h1.272V7.091zm2.545 0v6.364h1.273V7.091z",
    transform: "translate(-.888 2.603)",
    style: {
      fill: "#de233d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "2638315_bin_delete_dust_erace_garbage_icon",
    d: "M10.273 3.273V2H6.455v1.273H2v1.272h12.727V3.273z",
    transform: "rotate(-14.98 5.911 10.235)",
    style: {
      fill: "#de233d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOpened);
export default __webpack_public_path__ + "static/media/trash-opened.svg";
export { ForwardRef as ReactComponent };